// import React, { useState } from "react";
// import Clientsidebar from "../components/Clientsidebar";
// import Clientheader from "../components/Clientheader";
// import { useYearContext } from "../../admin/components/YearContext";
// import { LuPaperclip } from "react-icons/lu";
// import individual from "../pdf/Us Individual Tax Organizer.pdf";
// // import business from "../pdf/Us Business Tax Organizer.pdf";

// function Taxorganizer() {
//   const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
//   const openSidebar = () => {
//     setOpenSidebarToggle(!openSidebarToggle);
//   };

//   const { yearSelected } = useYearContext();

//   const files = [
//     {
//       file: individual,
//       name: "Us Individual Tax Organizer.pdf",
//     },
//     // {
//     // //   file: business,
//     // //   name: "Us Business Tax Organizer.pdf",
//     // // },
//   ];

//   // const handleDownload = (file) => {
//   //   const link = document.createElement("a");
//   //   link.href = file;
//   //   link.download = file.split("/").pop(); // Get the file name from the path
//   //   link.click();
//   // };

// const handleDownload = (file, name) => {
//   fetch(file)
//     .then((response) => response.blob())
//     .then((blob) => {
//       const link = document.createElement("a");
//       const url = window.URL.createObjectURL(blob);
//       link.href = url;
//       link.download = name; // ✅ exact name preserved
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//     })
//     .catch((error) => {
//       console.error("Error downloading file:", error);
//     });
// };

//   return (
//     <div className="client-grid-container">
//       <Clientheader openSidebar={openSidebar} />
//       <Clientsidebar
//         openSidebarToggle={openSidebarToggle}
//         openSidebar={openSidebar}
//       />
//       <main className="main-container mt-2">
//         <div className="container">
//           <h4>Tax Organizer</h4>

//           <div className="d-flex flex-column gap-3">
           
//            {
//             files.map((each) => (
//               <div className="d-flex justify-content-between align-items-center p-2 border border-secondary rounded ">
//               <p className="fw-semibold mb-0"><LuPaperclip className="me-2 mb-1"/>{each.name}</p>
//               <button className="btn btn-primary" onClick={() => handleDownload(each.file, each.name)}>Download</button>
//               </div>
//             ))
//            }
//           </div>
//         </div>
//       </main>
//     </div>
//   );
// }

// export default Taxorganizer;



import React, { useState } from "react";
import Clientsidebar from "../components/Clientsidebar";
import Clientheader from "../components/Clientheader";
import { useYearContext } from "../../admin/components/YearContext";
import { LuPaperclip } from "react-icons/lu";
import Easy_Tax_Experts_2025 from "../pdf/Easy Tax Experts Inc. TY 2025.docx";
import Easy_Tax_Experts_2024 from "../pdf/Easy Tax Experts Inc. TY 2024.docx";
import Easy_Tax_Experts_2023 from "../pdf/Easy Tax Experts Inc. TY 2023.docx";
import Easy_Tax_Experts_2022 from "../pdf/Easy Tax Experts Inc. TY 2022.docx";

function Taxorganizer() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const { yearSelected } = useYearContext();

  const files = [
    {
      year: 2025,
      file: Easy_Tax_Experts_2025,
      name: "Easy Tax Experts Inc. TY 2025.docx",
    },
    {
      year: 2024,
      file: Easy_Tax_Experts_2024,
      name: "Easy Tax Experts Inc. TY 2024.docx",
    },
    {
      year: 2023,
      file: Easy_Tax_Experts_2023,
      name: "Easy Tax Experts Inc. TY 2023.docx",
    },
    {
      year: 2022,
      file: Easy_Tax_Experts_2022,
      name: "Easy Tax Experts Inc. TY 2022.docx",
    },
  ];

  const selectedFile = files.find((file) => file.year == yearSelected);

  const handleDownload = () => {
    if (!selectedFile) return;
    const link = document.createElement("a");
    link.href = selectedFile.file;
    link.download = selectedFile.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="client-grid-container">
      <Clientheader openSidebar={openSidebar} />
      <Clientsidebar
        openSidebarToggle={openSidebarToggle}
        openSidebar={openSidebar}
      />
      <main className="main-container mt-2">
        <div className="container">
          <h4>Tax Organizer</h4>

          <div className="mt-3 d-flex align-items-center justify-content-between border p-2 rounded">
            <p className="mb-0">
              <LuPaperclip size={22} className="me-2" />

              {selectedFile ? (
                <span>{selectedFile.name}</span>
              ) : (
                <span>No file available for the selected year</span>
              )}
            </p>

            <button
              className="btn btn-sm btn-primary"
              onClick={handleDownload}
              title="Download File"
              disabled={!selectedFile}
            >
              Download
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Taxorganizer;